var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchFile } from '@evideo/web-ffmpeg';
import mime from 'mime';
import * as Comlink from "comlink";
export class MediaGenerator {
    constructor(options) {
        this.isLoad = false;
        this.options = Object.assign({
            log: true,
            pathPrefix: location.origin
        }, options);
        if (this.options.pathPrefix && this.options.pathPrefix !== ''
            && !this.options.pathPrefix.endsWith('/')) {
            this.options.pathPrefix += '/';
        }
        mime.define({
            'audio/aac': ['aac'],
            'audio/mpeg': ['mp3']
        }, true);
    }
    static getMediaGenerator(options) {
        return new MediaGenerator(options);
    }
    static getDefaultMediaGenerator(options) {
        var _a;
        return (_a = MediaGenerator.generator) !== null && _a !== void 0 ? _a : (MediaGenerator.generator = new MediaGenerator(options));
    }
    static removeDefaultMediaGenerator() {
        MediaGenerator.generator ? MediaGenerator.generator.close() : null;
        MediaGenerator.generator = undefined;
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoad) {
                return;
            }
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const response = yield fetch(`${this.options.pathPrefix}js/ffmpeg.worker-0.3.2.js`);
                const text = yield response.text();
                this._workerUrl = window.URL.createObjectURL(new Blob([text], {
                    type: 'application/javascript'
                }));
                this._worker = new Worker(this._workerUrl, { name: 'ffmpeg' });
                this._worker.onerror = (event) => {
                    this.isLoad = false;
                    console.error(event);
                    reject(new Error('ffmpeg load fail'));
                };
                this._worker.postMessage('');
                this.isLoad = true;
                resolve(true);
            }));
        });
    }
    /**
     *  释放内存, 无法继续使用这个对象
     */
    close() {
        var _a;
        (_a = this._worker) === null || _a === void 0 ? void 0 : _a.terminate();
        if (this._workerUrl) {
            URL.revokeObjectURL(this._workerUrl);
        }
    }
    /**
     * 设置进度回调
     * @param progress
     */
    setProgress(progress) {
        this._progress = progress;
    }
    static toMaterial(material) {
        if (material instanceof File || material instanceof Blob) {
            let type;
            if (material.type.startsWith('video')) {
                type = 'video';
            }
            else if (material.type.startsWith('audio')) {
                type = 'audio';
            }
            else {
                throw new Error(`${material.type} is unknown`);
            }
            return {
                data: material,
                type,
                ext: mime.getExtension(material.type)
            };
        }
        return material;
    }
    getFFmpeg() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.load();
            if (this._ffmpeg) {
                return this._ffmpeg;
            }
            if (!this._worker) {
                throw new Error('ffmpeg worker is undefined');
            }
            const WrapWebFFmpeg = Comlink.wrap(this._worker);
            // @ts-ignore
            this._ffmpeg = (yield new WrapWebFFmpeg({
                log: true,
                pathPrefix: `${this.options.pathPrefix}js/`
            }));
            if (this._progress) {
                this._ffmpeg.setProgress(Comlink.proxy(this._progress));
            }
            return this._ffmpeg;
        });
    }
    codecs() {
        return __awaiter(this, void 0, void 0, function* () {
            const ffmpeg = yield this.getFFmpeg();
            yield ffmpeg.run(['-codecs']);
        });
    }
    /**
     * 合并两个媒体文件，其中一个可以是视频; 可以修改音量和音频延迟
     *  返回blob, mimeType: video/mp4 audio/mp3
     * @param material0
     * @param material1
     * @param options
     */
    mergeSound(material0, material1, options) {
        return __awaiter(this, void 0, void 0, function* () {
            material0 = MediaGenerator.toMaterial(material0);
            material1 = MediaGenerator.toMaterial(material1);
            options = Object.assign({
                volume0: 1,
                volume1: 1,
                delay0: 0,
                delay1: 0,
                sampleRate: 44100,
                ext: 'mp4'
            }, options);
            if (material0.type === 'video' && material1.type === 'video') {
                throw new Error('only one material can be video');
            }
            if (material1.type === 'video') {
                throw new Error('material1 must be audio');
            }
            if (options.volume0 && (options.volume0 < 0 || options.volume0 > 4)
                || options.volume1 && (options.volume1 < 0 || options.volume1 > 4)) {
                throw new Error('volume must in [0, 4]');
            }
            const args = [];
            if (options.delay0 && options.delay0 > 0) {
                // delay
                if (material0.type === 'video') {
                    args.push('-itsoffset', `${options.delay0}ms`);
                }
            }
            else if (options.delay0 && options.delay0 < 0) {
                // advance
                args.push('-ss', `${-options.delay0}ms`);
                options.delay0 = 0;
            }
            args.push('-i', 'material0');
            if (options.delay1 && options.delay1 > 0) {
                // delay material1 是音频
            }
            else if (options.delay1 && options.delay1 < 0) {
                // advance
                args.push('-ss', `${-options.delay1}ms`);
                options.delay1 = 0;
            }
            args.push('-i', 'material1', '-filter_complex', `[0]volume=${options.volume0},adelay=${options.delay0}|${options.delay0}[aout0]; \
                          [1]volume=${options.volume1},adelay=${options.delay1}|${options.delay1}[aout1]; \
                          [aout0][aout1]amix=inputs=2:duration=shortest[aout]`);
            let outputName;
            let mimeType;
            if (material0.type === 'video') {
                args.push('-c:v', 'copy', '-map', '0:v', '-map', '[aout]');
                if (options.ext === 'mp4') {
                    args.push('-ar', `${options.sampleRate}`);
                    outputName = 'output.mp4';
                    mimeType = 'video/mp4';
                }
                else if (options.ext === 'webm') {
                    args.push('-strict', '-2', '-c:a', 'opus');
                    outputName = 'output.webm';
                    mimeType = 'video/webm';
                }
                else {
                    throw new Error(`The ${options.ext} suffix is not supported`);
                }
            }
            else {
                args.push('-map', '[aout]', '-ar', `${options.sampleRate}`);
                outputName = 'output.mp3';
                mimeType = 'audio/mp3';
            }
            args.push(outputName);
            const ffmpeg = yield this.getFFmpeg();
            const result = yield ffmpeg.run(args, [{
                    name: 'material0',
                    data: yield fetchFile(material0.data)
                }, {
                    name: 'material1',
                    data: yield fetchFile(material1.data)
                }]);
            if (result.length !== 1) {
                throw new Error('ffmpeg run fail');
            }
            return new Blob([result[0].data.buffer], { type: mimeType });
        });
    }
    /**
     * 视频截图
     * @param video
     * @param time 快照时间 单位:ms
     * @param options
     */
    snapshot(video, time, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = MediaGenerator.toMaterial(video);
            if (material.type !== 'video') {
                throw new Error('only video can be snapped');
            }
            options = Object.assign({
                format: 'jpeg',
                quality: 5
            }, options);
            time /= 1000;
            const outputName = `output.${options.format}`;
            const args = ['-i', 'material', '-vframes', '1', '-ss', `${time}`,
                '-q:v', `${options.quality}`];
            if (options.size) {
                args.push('-s', `${options.size}`);
            }
            args.push(outputName);
            const ffmpeg = yield this.getFFmpeg();
            const result = yield ffmpeg.run(args, [{
                    name: 'material',
                    data: yield fetchFile(material.data)
                }]);
            if (result.length !== 1) {
                throw new Error('ffmpeg run fail');
            }
            return new Blob([result[0].data.buffer], { type: `image/${options.format}` });
        });
    }
    /**
     * 变速变调
     */
    changeTempoAndPitch(audio, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = MediaGenerator.toMaterial(audio);
            if (material.type !== 'audio') {
                throw new Error('only audio can be chagneTempoAndPitch');
            }
            if (!options.tempo && !options.pitch) {
                throw new Error('tempo and pitch is null');
            }
            if (options.tempo) {
                if (options.tempo < 0.0625 || options.tempo > 8) {
                    throw new Error('tempo is in [0.0625,8]');
                }
            }
            if (options.pitch) {
                if (options.pitch < -12 || options.pitch > 12) {
                    throw Error('pitch is in [-12,12]');
                }
            }
            options = Object.assign({
                format: 'wav',
                sampleRate: 44100
            }, options);
            const audioData = yield fetchFile(material.data);
            const toAtempoStr = (tempo) => {
                if (!tempo)
                    return '';
                if (tempo < 0.25) {
                    return `atempo=${Math.pow(tempo, 1 / 3)},atempo=${Math.pow(tempo, 1 / 3)},atempo=${Math.pow(tempo, 1 / 3)}`;
                }
                else if (tempo >= 0.25 && tempo < 0.5) {
                    return `atempo=${Math.pow(tempo, 1 / 2)},atempo=${Math.pow(tempo, 1 / 2)}`;
                }
                else if (tempo >= 0.5 && tempo <= 2) {
                    return `atempo=${tempo}`;
                }
                else if (tempo > 2 && tempo <= 4) {
                    return `atempo=${Math.pow(tempo, 1 / 2)},atempo=${Math.pow(tempo, 1 / 2)}`;
                }
                else if (tempo > 4) {
                    return `atempo=${Math.pow(tempo, 1 / 3)},atempo=${Math.pow(tempo, 1 / 3)},atempo=${Math.pow(tempo, 1 / 3)}`;
                }
                else {
                    return '';
                }
            };
            const args = ['-i', 'material', '-filter_complex'];
            const argTempo = toAtempoStr(options.tempo);
            const argPitch = `aresample=${options.sampleRate},asetrate=${options.sampleRate}*2^(${options.pitch}/12),atempo=1/2^(${options.pitch}/12)`;
            if (options.tempo && !options.pitch) {
                // 只变速
                args.push(argTempo);
            }
            else if (!options.tempo && options.pitch) {
                // 只变调
                args.push(argPitch);
            }
            else if (options.tempo && options.pitch) {
                // 既变速又变调
                args.push(`${argPitch},${argTempo}`);
            }
            args.push('-ar', `${options.sampleRate}`, '-ac', '1', `output.${options.format}`);
            const ffmpeg = yield this.getFFmpeg();
            const result = yield ffmpeg.run(args, [{
                    name: 'material',
                    data: audioData
                }]);
            if (result.length !== 1) {
                throw new Error('ffmpeg run fail');
            }
            return new Blob([result[0].data.buffer], { type: `audio/${options.format}` });
        });
    }
    /**
     * 音视频剪切
     * @param media
     * @param options
     */
    cut(media, options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const material = MediaGenerator.toMaterial(media);
            const ffmpeg = yield this.getFFmpeg();
            const args = ['-i', 'material'];
            args.push('-ss', `${options.startTime}ms`, '-t', `${options.duration}ms`);
            if (!options.format || material.ext === options.format) {
                args.push('-c', 'copy');
            }
            args.push(`output.${(_a = options.format) !== null && _a !== void 0 ? _a : material.ext}`);
            const result = yield ffmpeg.run(args, [{
                    name: 'material',
                    data: yield fetchFile(material.data)
                }]);
            return new Blob([result[0].data.buffer], { type: `${material.type}/${(_b = options.format) !== null && _b !== void 0 ? _b : material.ext}` });
        });
    }
}
